import React, { createContext, useContext, useState, useEffect } from 'react';
import client from '../utils/fetchClient';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUser = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log('Fetching user profile...');
      const res = await client.get('/api/users/me');
      if (!res.ok) throw new Error('Failed to fetch user profile');
      const data = await res.json();
      console.log('User profile data:', data);
      setUser(data);
    } catch (err) {
      setError(err.message || 'Error fetching user profile');
      console.error('Error fetching user:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
  };

  const updateAvatar = (avatarUrl) => {
    setUser(prev => prev ? { ...prev, avatarUrl } : null);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const value = {
    user,
    loading,
    error,
    fetchUser,
    updateUser,
    updateAvatar
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}
